export const blogCategories = ["Todos", "Fiscal", "Laboral", "Agrario", "Autónomos", "Seguros"];

export const blogPosts = [
  {
    id: 1,
    category: "Agrario",
    title: "Ayudas PAC 2025 para agricultores de la Marina Alta: plazos y requisitos",
    excerpt: "La nueva PAC 2025-2027 trae cambios en los eco-regímenes y los pagos directos para cultivos de cítricos y almendros. Te explicamos qué condiciones debes cumplir y cómo solicitar las ayudas antes de que cierren los plazos en la Comunitat Valenciana.",
    author: "Vidal Ferrer Asesores",
    date: "18 Mar 2025",
    readTime: "6 min",
    image: "https://public.readdy.ai/ai/img_res/142763c59336eb841a6628f111d3c951.jpg",
    featured: true,
    tags: ["PAC 2025", "Cítricos", "Ajudes agrícoles"]
  },
  {
    id: 2,
    category: "Fiscal",
    title: "Módulos para agricultores: ¿Qué es el régimen de estimación objetiva y cuándo conviene?",
    excerpt: "La mayoría de agricultors de la Marina Alta tributan en módulos (estimació objectiva). Analizamos los índices correctores para la zona, cómo declarar las ventas de naranja y cuando puede ser más ventajoso pasar a estimación directa simplificada.",
    author: "Vidal Ferrer Asesores",
    date: "10 Mar 2025",
    readTime: "7 min",
    image: "https://readdy.ai/api/search-image?query=Spanish%20tax%20documents%20farmer%20agricultural%20fiscal%20declaration%20forms%20calculator%20pen%20desk%20rustic%20wood%20office%20warm%20light%20Mediterranean%20style%20professional&width=600&height=380&seq=b2&orientation=landscape",
    featured: false,
    tags: ["Módulos", "IRPF Agrícola", "Estimació objectiva"]
  },
  {
    id: 3,
    category: "Laboral",
    title: "Temporeros en la taronja: obligaciones del empresario agrícola en la Comunitat Valenciana",
    excerpt: "La campaña de recolección de cítricos en Pego, El Verger y la Safor implica contratar trabajadores temporales. Repasamos los contratos eventuales, el Sistema Especial Agrario de la Seguridad Social y las multas más habituales por incumplimiento.",
    author: "Vidal Ferrer Asesores",
    date: "03 Mar 2025",
    readTime: "5 min",
    image: "https://readdy.ai/api/search-image?query=agricultural%20workers%20harvesting%20oranges%20citrus%20fruit%20orchard%20Spain%20Mediterranean%20warm%20light%20hands%20picking%20fruit%20rural%20countryside%20Valencia%20Alicante&width=600&height=380&seq=b3&orientation=landscape",
    featured: false,
    tags: ["Temporeros", "SEASS", "Contrato Agrícola"]
  },
  {
    id: 4,
    category: "Autónomos",
    title: "Cuota de autónomos 2025: la nueva cotización por ingresos reales y cómo afecta a los trabajadores de la Marina Alta",
    excerpt: "Con el nuevo sistema de cotización por ingresos reales, muchos autónomos de la zona —paletes, electricistes, perruquers— pueden pagar menys si declaren correctament. T'expliquem els 15 trams i com triar la base de cotització òptima.",
    author: "Vidal Ferrer Asesores",
    date: "24 Feb 2025",
    readTime: "6 min",
    image: "https://readdy.ai/api/search-image?query=Spanish%20freelancer%20self-employed%20worker%20tradesman%20electrician%20small%20business%20owner%20professional%20portrait%20office%20desk%20laptop%20documents%20warm%20neutral%20Mediterranean%20background&width=600&height=380&seq=b4&orientation=landscape",
    featured: false,
    tags: ["Autónomos", "Cuota 2025", "Ingresos Reales"]
  },
  {
    id: 5,
    category: "Fiscal",
    title: "Sucessions i donacions a la Comunitat Valenciana: bonificaciones del 75% que muchas familias de Pego desconocen",
    excerpt: "En la Comunitat Valenciana, heredar o donar un negocio familiar agrícola entre cónyuge o fills pot tindre una bonificació del 75% en l'impost de successions. T'expliquem les condicions i com planificar la transmissió del patrimoni familiar.",
    author: "Vidal Ferrer Asesores",
    date: "14 Feb 2025",
    readTime: "8 min",
    image: "https://readdy.ai/api/search-image?query=family%20inheritance%20estate%20planning%20documents%20signing%20notary%20office%20Spain%20Mediterranean%20professional%20warm%20neutral%20background%20legal%20papers%20family%20business%20transfer&width=600&height=380&seq=b5&orientation=landscape",
    featured: false,
    tags: ["Successions", "Donacions", "Empresa Familiar"]
  },
  {
    id: 6,
    category: "Seguros",
    title: "Seguro agrícola para cítricos y almendros en la Marina Alta: coberturas ante heladas y pedrisco",
    excerpt: "La última borrasca que afectó la comarca de El Comtat y la Marina Alta deixà moltes explotacions sense collita. Analitzem les cobertures del pla d'assegurances agràries de l'ENESA i com contractar-les des de Pego o Dénia.",
    author: "Vidal Ferrer Asesores",
    date: "05 Feb 2025",
    readTime: "5 min",
    image: "https://readdy.ai/api/search-image?query=frost%20damaged%20citrus%20orange%20trees%20agricultural%20field%20Mediterranean%20Spain%20winter%20cold%20damage%20insurance%20concept%20Alicante%20Valencia%20countryside%20farm&width=600&height=380&seq=b6&orientation=landscape",
    featured: false,
    tags: ["Assegurança Agrícola", "ENESA", "Cítricos"]
  }
];
